import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBModalBody, MDBSpinner } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { getPortingDetails, getPortingFiles } from "../../../apiclients/streamsapi_bridge";
import { formattedNumber } from "./AddRemoveNumbers";

export default function ValidatedOrderDetails(props) {
    const [orderInfo, setOrderInfo] = useState({});
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [failedErrorMessage, setFailedErrorMessage] = useState('');

    async function getOrderInfo(orderId) {
        try {
            setInternalError(false);
            console.log(`Order Id ::${orderId}`);
            setIsloading(true);
            let apiResponse = await getPortingDetails(JSON.parse(sessionStorage.getItem("admin_session")).siteid, orderId);
            setTimeout(() => { setIsloading(false) }, 1000);
            let resData = await apiResponse.json();
            if (apiResponse.status == 200) {
                setOrderInfo(resData?.tn_order_details ?? {});
            } else {
                setInternalError(true);
            }
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }

    async function downloadFiles(orderId, downloadType, fileName) {
        try {
            let apiResponse = await getPortingFiles(JSON.parse(sessionStorage.getItem("admin_session")).siteid, orderId, downloadType);
            if (apiResponse.status == 200) {
                const fileUrl = URL.createObjectURL(await apiResponse.blob());
                let nameOfFile = fileName;
                if (downloadType === 11) {
                    const contentDisposition = apiResponse.headers.get("Content-Disposition");
                    if (contentDisposition) {
                        const match = contentDisposition.match(/filename ="?([^"]+)"?/);
                        if (match && match[1]) {
                            nameOfFile = match[1].trim();
                        }
                    }
                }
                const a = document.createElement('a');
                a.href = fileUrl;
                a.download = nameOfFile;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } else {
                setInternalError(true);
            }
        } catch (error) {
            console.log(`Unable to processs the request : Internal server Errro :${error}`);
            setInternalError(true);
        }
    }

    useEffect(() => {
        if (props.orderId) {
            getOrderInfo(props.orderId);
        }
    }, [props.orderId]);

    const [showAll, setShowAll] = useState(false);
    const [showAllLoa, setShowAllLoa] = useState(false);

    let phoneNumbers = Array.isArray(orderInfo.validated_numbers)
        ? orderInfo.validated_numbers
        : (orderInfo.validated_numbers || '').toString().split(',');
    phoneNumbers = phoneNumbers.map(num => formattedNumber(num));

    let loafiles = Array.isArray(orderInfo?.upload_latest_bill)
        ? orderInfo?.upload_latest_bill
        : (orderInfo?.upload_latest_bill || '').toString().split(',');
    console.log("loafiles", JSON.stringify(loafiles));
    loafiles = loafiles.map(fil => fil.file_name);

    console.log("loafiles", JSON.stringify(loafiles));

    const toggleShowAllLoa = () => {
        setShowAllLoa((prev) => !prev);
    };

    const hasMoreLoa = loafiles.length > 3;
    const displayedLoa = showAllLoa ? loafiles : loafiles.slice(0, 3);
    const numbersStringLoa = displayedLoa.join(', ') + (hasMoreLoa && !showAllLoa ? '...' : '');

    const toggleShowAll = () => {
        setShowAll((prev) => !prev);
    };

    const hasMore = phoneNumbers.length > 3;
    const displayedNumbers = showAll ? phoneNumbers : phoneNumbers.slice(0, 3);
    const numbersString = displayedNumbers.map((num, index) => (
        <span key={index} style={{ wordBreak: "keep-all", display: "inline-block" }}>{num}</span>
    )).reduce((acc, curr, index) => {
        if (index === 0) return [curr];
        return [...acc, ', ', curr];
    }, []);

    return (
        <>
            <div className="pb-3">

                {orderInfo.acc_info?.company_name && (
                    <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                        <div className="w-30">Company Name:</div>
                        <div>{orderInfo.acc_info.company_name}</div>
                    </div>
                )
                }
                {/* {props.portingType && props.portingType === 3 && (
                        <div className='d-flex align-items-center' style={{minHeight: '30px'}}>
                            <div className="w-30">Account Name:</div>
                            <div>{JSON.parse(sessionStorage.getItem("admin_session")).sitename}</div>
                        </div>
                    )} */}
                <div className='d-flex align-items-center mt-2' style={{ minHeight: '30px' }}>
                    <div className="w-30">Date & Time:</div>
                    <div>{orderInfo.created_date}</div>
                </div>
                {orderInfo.status_value == 'Verified' && (
                    <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                        <div className="w-30">Approved Date & Time:</div>
                        <div>{orderInfo.created_by}, {orderInfo.validated_date} {orderInfo.ipaddress ? `IP:${orderInfo.ipaddress}` : ""}</div>
                    </div>
                )
                }
                <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                    <div className="w-30">Order Number:</div>
                    <div>{orderInfo.order_id}</div>
                </div>
                <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                    <div className="w-30">{props.portingType && props.portingType === 3 ? "Validated Phone Number(s):" : "Porting Numbers:"}</div>
                    <div className="w-70">
                        {numbersString}
                        {hasMore && (
                            <span
                                onClick={toggleShowAll}
                                style={{ color: 'blue', cursor: 'pointer', marginLeft: '8px' }}
                            >
                                {showAll ? '- view less' : '+ view more'}
                            </span>
                        )}
                    </div>
                </div>
                <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                    <div className="w-30">Status:</div>
                    <div>{orderInfo.status_value}</div>
                </div>
                <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                    <div className="w-30">{props.portingType && props.portingType === 3 ? "Latest Copy of Bill:" : "Uploaded Latest Copy of Bill or CSR:"}</div>
                    <div className="d-flex align-items-center w-70">{numbersStringLoa}
                        {hasMoreLoa && (
                            <span
                                onClick={toggleShowAllLoa}
                                style={{ color: 'blue', cursor: 'pointer', marginLeft: '8px' }}
                            >
                                {showAllLoa ? '- view less' : '+ view more'}
                            </span>
                        )}
                        <div className='ms-2 cursor-pointer' onClick={(e) => { e.stopPropagation(); downloadFiles(orderInfo.order_id, 11, JSON.parse(sessionStorage.getItem("admin_session")).sitename + '_' + orderInfo.order_id + '.zip') }}><MDBIcon fas icon="download" /></div> <MDBIcon className='ms-2 cursor-pointer toolbar_item' far icon="question-circle" /></div>
                </div>
                <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                    <div className="w-30">LOA:</div>
                    <div className="d-flex align-items-center">{orderInfo.loa_filename} <div className='ms-2 cursor-pointer' onClick={(e) => { e.stopPropagation(); downloadFiles(orderInfo.order_id, 12, orderInfo.loa_filename) }}><MDBIcon fas icon="download" /></div></div>
                </div>

                {orderInfo.created_by && props.portingType && props.portingType !== 3 && (
                    <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                        <div className="w-30">Requested By:</div>
                        <div>{orderInfo.created_by}</div>
                    </div>
                )
                }
                {orderInfo.notifs_comments?.contact_ph_num && (
                    <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                        <div className="w-30">Telephone Numbers Attached:</div>
                        <div>{formattedNumber(orderInfo.notifs_comments.contact_ph_num)}</div>
                    </div>
                )
                }
                {orderInfo.notifs_comments?.email && (
                    <div className='d-flex align-items-center' style={{ minHeight: '30px' }}>
                        <div className="w-30">Send Email To:</div>
                        <div>{orderInfo.notifs_comments.email}</div>
                    </div>
                )
                }
                {orderInfo.foc_date_details?.length > 0 && (

                    <MDBDatatable data={{
                        columns: [
                            { label: "TELEPHONE NO.", field: "phone_number", sort: false },
                            { label: "FOC SECURED DATE", field: "date", sort: false },
                        ],
                        rows: orderInfo.foc_date_details
                    }} pagination={false}
                        entries={orderInfo.foc_date_details?.length}
                        noFoundMessage={"No records found."}
                    />
                )}

            </div>

            <Tooltip anchorSelect=".toolbar_item" place="top">
                All the copy of bill(s) will be downloaded as a zip archive
            </Tooltip>

            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}

            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}

            {failedErrorMessage !== "" && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setFailedErrorMessage("")}
                >
                    {failedErrorMessage}
                </MDBAlert>
            )}

        </>
    );
}